export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty or unreachable, a code-drawn cover is shown. */
  cover?: string
}

/** Covers: "DPS36 - Bono N - ….png" */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Flight Plan: Your Whole Year, Mapped',
    short: 'The Flight Plan',
    body: 'The map that turns six volumes into a year of classes without thinking: which class to run first, how the volumes chain across your terms, a 30-day quick-start and a “which class for which student” decision map.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/tnixAQAenMbzDuS8cKsBXD/DPS36_-_Bono_1_-_The_Flight_Plan.png',
  },
  {
    number: '02',
    title: 'The In-Class Confidence Cheat-Sheet',
    short: 'In-Class Confidence',
    body: 'The 15 tricky moments that happen in the air — a student stuck up top, can’t come down, gets frustrated or teary, gear that “feels weird” — and exactly what to do, what to say and when to stop the class.',
    accent: 'bg-teal',
    cover: 'https://cdn.magicpatterns.com/uploads/tKP5ftxadHAPrT5YvzAEoZ/DPS36_-_Bono_2_-_The_In-Class_Confidence_Cheat-Sheet.png',
  },
  {
    number: '03',
    title: 'The 15-Minute Placement Drill',
    short: 'Placement Drill',
    body: 'A ready 15-minute routine to place any new student on the right rung of the ladder — on silks, hoop or trapeze — mid-term, without stopping your class.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/qfi9xgCuzbkv3eAH8fRDu1/DPS36_-_Bono_3_-_The_15-Minute_Placement_Drill.png',
  },
  {
    number: '04',
    title: 'The First-Class FAQ & Answer Scripts',
    short: 'First-Class FAQ',
    body: 'Ready answers to the 20 questions new students always ask — what do I wear, will it hurt, am I too heavy or too old, how long until I can do it, is it safe — plus how to reassure the nervous beginner on the spot.',
    accent: 'bg-indigo',
    cover: 'https://cdn.magicpatterns.com/uploads/vCBRDk1znu73HCZLaYc4B8/DPS36_-_Bono_4_-_The_First-Class_FAQ__Answer_Scripts.png',
  },
  {
    number: '05',
    title: 'The Copyright-Safe Music & Playlist Kit',
    short: 'Music & Playlist Kit',
    body: 'Where to find license-free music, a shortlist by mood and BPM, and 6 plug-and-play playlist structures for warm-up, skill, sequence and cool-down.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/uT56sCToFQYUvh8GjMcn7m/DPS36_-_Bono_5_-_The_Copyright-Safe_Music__Playlist_Kit.png',
  },
]
